// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"WebinarTy_subtitle__0mbp1","secondaryTitle":"WebinarTy_secondaryTitle__j_wlr","boxText":"WebinarTy_boxText__wzmyZ","button":"WebinarTy_button__CjJ4u"};